import { shiftParticipantEntityName } from '../../../../backend/features/shift/shared';
import { useMissionsTranslation } from '../../../../ui/hooks';
import ImportGuidelines from '@juvare/contact-management/ui/features/accounts/components/AccountsPanel/components/ImportGuidelines';
import { showEntityImportDialog } from '@juvare/platform-sdk-react/ui/features/entity-import';
import React from 'react';
const csvTemplateArray = ['FIRST_NAME', 'LAST_NAME', 'EMAIL*', 'POSITION*', 'STATUS', 'HOURS'];
export const useShiftParticipantImport = () => {
    const { t } = useMissionsTranslation();
    const importShiftParticipants = ({ onAfterImport, shiftId }) => {
        showEntityImportDialog({
            entity: shiftParticipantEntityName,
            options: {
                dialogTitle: t('shifts.adminTimeTracking.importHoursDialog.title'),
                csvTemplate: csvTemplateArray.join(','),
                csvTemplateName: t('shifts.adminTimeTracking.importHoursDialog.csvTemplateName'),
                additionalDialogContent: React.createElement(ImportGuidelines, null),
                onAfterImport,
                metadata: {
                    shiftId,
                },
            },
        });
    };
    return { importShiftParticipants };
};
